import { render, staticRenderFns } from "./ProviderCredit.vue?vue&type=template&id=538f21f7&"
import script from "./ProviderCredit.vue?vue&type=script&lang=ts&"
export * from "./ProviderCredit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports